import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import StatusContainer from "../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import ICONS from "../../../assets/Icons";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import {
  extractFieldForceCreateErrorMessages,
  readFieldForceCreateError,
} from "../../../utils/fieldForceCreateError";

const FieldForceAccountError = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const errorMessages = useMemo(() => {
    const errorState = readFieldForceCreateError(state);
    if (!errorState) return [];
    if (typeof errorState === "string") return [errorState];
    if (Array.isArray(errorState)) {
      return errorState.filter(
        (msg) => typeof msg === "string" && msg.trim(),
      );
    }
    return extractFieldForceCreateErrorMessages(errorState);
  }, [state]);

  const createAccountHandler = () => {
    navigate("/field_force_account_dashboard/create_field_force_account");
  };

  const dashboardHandler = () => {
    navigate("/field_force_account_dashboard");
  };

  const buttonRows = [
    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS.ADD_BUTTON_WHITE,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--negative-bg)",
      },
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];

  return (
    <StatusContainer
      status="error"
      title="Failed to create field force account."
      buttonRows={buttonRows}
      hoverOption="white"
    >
      <TabsWeapperSection title="Error details">
        <div className="flex flex-col">
          {errorMessages.length > GlobalConfiguration.lengthCheckZero ? (
            errorMessages.map((msg, index) => (
              <InfoCard
                key={index}
                bgColor="var(--negative-card)"
                rows={[
                  {
                    leftTitle: msg,
                    leftSubTitle: "Error description",
                  },
                ]}
              />
            ))
          ) : (
            <InfoCard
              bgColor="var(--negative-card)"
              rows={[
                {
                  leftTitle: "An unknown error occurred",
                  leftSubTitle: "Error description",
                },
              ]}
            />
          )}
        </div>
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default FieldForceAccountError;
